export default "__VITE_PUBLIC_ASSET__f7327ab6__"